import { inventories } from "@/api/inventories/useInventoriesQuery";
import { MantineSelectableTable } from "@/features/ui/table/MantineSelectableTable";
import { setToLocaleString } from "@/utils/unitMark";
import {
  AuthSignupPost201ResponseEquipmentWorksInner,
  ProductionPlansGet200ResponseRowsInnerWorksInner,
  ProductionPlansGet200ResponseRowsInnerWorksInnerLocationSetting,
} from "@sizlcorp/sizl-api-document/dist/models";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { t } from "i18next";
import { MRT_ColumnDef } from "mantine-react-table";
import { useMemo } from "react";

export const InputMaterialCheckViewForm = ({
  rowData,
}: {
  rowData:
    | (AuthSignupPost201ResponseEquipmentWorksInner & {
        locationSetting: ProductionPlansGet200ResponseRowsInnerWorksInnerLocationSetting;
      })
    | ProductionPlansGet200ResponseRowsInnerWorksInner;
}) => {
  const { data } = useQuery(
    inventories.find({
      query: {
        $and: [
          {
            locationCode: rowData?.locationSetting?.toLocation?.code,
          },
          { quantity: { $ne: 0 } },
        ],
      },
      populate: ["item", "lot"],
      sort: "createdAt",
    }),
  );

  const inventory = data?.data;

  const columns = useMemo<MRT_ColumnDef[]>(
    () => [
      {
        accessorKey: "itemCode",
        header: t("item.code"),
      },
      {
        accessorKey: "lotName",
        header: t("lot.name"),
      },
      {
        accessorKey: "lotExpiration",
        header: t("lot.expiration"),
      },
      {
        accessorKey: "remainQuantity",
        header: t("work.remainQuantity"),
      },
    ],
    [],
  );

  const convertedInventoryData = inventory?.map((row) => {
    return {
      itemCode: row.itemCode,
      lotName: row.lot?.name ?? "-",
      lotExpiration: row.lot?.expiration ? dayjs(row.lot?.expiration).format("YYYY-MM-DD") : "-",
      remainQuantity: setToLocaleString(row.quantity ?? "") + " " + row.unitText,
    };
  });

  return (
    <MantineSelectableTable
      enableRowSelection={false}
      columns={columns}
      data={convertedInventoryData ?? []}
    />
  );
};
